import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { NotifMailParams } from 'src/app/shared/models';
import { ConfigDto } from 'src/app/shared/interfaces';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MeService } from 'src/app/shared/services/me.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  public form = new FormGroup({
    enabled: new FormControl(null),
    weekDays: new FormControl(null),
    hours: new FormControl(null),
    tags: new FormControl(null),
  });

  public weeks: { label: string; value: number }[] = [
    {
      label: 'Lundi',
      value: 2,
    },
    {
      label: 'Mardi',
      value: 3,
    },
    {
      label: 'Mercredi',
      value: 4,
    },
    {
      label: 'Jeudi',
      value: 5,
    },
    {
      label: 'Vendredi',
      value: 6,
    },
    {
      label: 'Samedi',
      value: 7,
    },
    {
      label: 'Dimanche',
      value: 1,
    },
  ];
  public hours: { label: string; value: number }[] = [];
  public tags: { label: string; value: string }[] = [];

  constructor(
    private meService: MeService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private configService: ConfigService
  ) {}

  public ngOnInit(): void {
    this.spinner.show();
    this.setDatas();
  }

  private setDatas(): void {
    for (let i = 0; i <= 23; i++) {
      this.hours.push({ label: i + 'h', value: i });
    }
    forkJoin({
      config: this.configService.fetchConfig(),
      notifications: this.meService.getAllNotifications(),
    }).subscribe((res) => {
      this.getTags(res.config);
      this.form.patchValue(res.notifications);
      this.spinner.hide();
    });
  }

  private getTags(res: ConfigDto): void {
    if (res.searchTags && res.searchTags.length > 0) {
      for (const [key, value] of Object.entries(res.searchTags[1].values)) {
        this.tags.push({ label: value, value: key });
      }
    }
  }

  public submitNotifications(): void {
    if (this.form.valid) {
      const params = new NotifMailParams(this.form.value);
      this.meService.postNotifications(params).subscribe({
        next: () => {
          this.toastr.success('Le paramètre a bien été enregistré');
          this.getNotifications();
        },
      });
    } else {
      this.toastr.error('Veuillez remplir tous les champs');
    }
  }

  public resetNotifications(): void {
    this.meService.deleteNotifications().subscribe({
      next: () => {
        this.getNotifications();
        this.toastr.success('Les valeurs ont bien été réinitialisées aux valeurs de base de la configuration');
      },
    });
  }

  private getNotifications(): void {
    this.meService.getAllNotifications().subscribe({
      next: (res) => {
        this.form.patchValue(res);
      },
    });
  }
}
